import { useEffect } from 'react';
import { ClientFlags, OnboardingTrialStepsType } from '@sdk/authentication/types';

import type {
  RestangularEmployee,
  RestangularPosition,
} from '@web/onboarding/Checklist/DefineWagesModal/defineWagesModal.types';
import type { CompleteStep } from '@web/onboarding/Checklist/hooks/useCompleteStep';
import isStepCompleted from '@web/onboarding/Checklist/helpers/isStepCompleted';
import areAnyWagesCreated from '@web/onboarding/Checklist/helpers/areAnyWagesCreated';

type Props = {
  availableSteps: OnboardingTrialStepsType[];
  completeStep: CompleteStep;
  clientFlags: ClientFlags;
  employees: RestangularEmployee[];
  positions: RestangularPosition[];
};
const useAutocompleteDefineEmployeeWagesStep = ({
  availableSteps,
  completeStep,
  clientFlags,
  employees,
  positions,
}: Props) => {
  useEffect(() => {
    if (!clientFlags) {
      // if we don't have client flags at all we're not ready to mark it completed, waiting for them to load.
      return;
    }

    if (isStepCompleted(clientFlags, OnboardingTrialStepsType.defineWages)) {
      // step was completed before, no need to proceed further
      return;
    }

    if (areAnyWagesCreated(employees, positions)) {
      completeStep(OnboardingTrialStepsType.defineWages, availableSteps);
    }
  }, [availableSteps, completeStep, employees, positions, clientFlags]);
  return null;
};

export default useAutocompleteDefineEmployeeWagesStep;
